export default __webpack_public_path__ + "static/media/kitchen3-before3-1440w.4ef31a0f.png";